import React from 'react';
import css from './index.module.scss'


export default () => (
    <footer className = {css.footer}>
        <p>Copyright © 2020-2021 | Made by <span>Anton Savytskyi</span></p>
  
    </footer>
   
)